// extracted by mini-css-extract-plugin
export var modalFooter = "_lb-0";